var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon_Maintenance_of_technical_data"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_Maintenance_of_technical_data",
    "data-name": "icon_Maintenance of technical data",
    clipPath: "url(#clip-icon_Maintenance_of_technical_data)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M816,112H208a96,96,0,0,0-96,96V816a96,96,0,0,0,96,96H816a96,96,0,0,0,96-96V208A96,96,0,0,0,816,112ZM540,168H816a40.047,40.047,0,0,1,40,40V484H742.46a16,16,0,0,0-16,16v79.61h-.02a28.605,28.605,0,1,1-57.21,0h-.02V500a16,16,0,0,0-16-16H540V409.73h39.61v.14a84.6,84.6,0,1,0,0-169.21v.03H540ZM168,208a40.047,40.047,0,0,1,40-40H484V280.64a16,16,0,0,0,16,16h79.61v.02a28.6,28.6,0,1,1,0,57.21v.02H500a16,16,0,0,0-16,16V484H410.5V444.39h.14a84.605,84.605,0,1,0-169.21,0h.03V484H168ZM484,856H208a40.04,40.04,0,0,1-40-40V540H281.42a16,16,0,0,0,16-16V444.39h.01a28.605,28.605,0,1,1,57.21,0h.02V524a16,16,0,0,0,16,16H484v73.95H444.39v-.14a84.61,84.61,0,0,0,0,169.22V783H484Zm372-40a40.04,40.04,0,0,1-40,40H540V743.04a16,16,0,0,0-16-16H444.39v-.01a28.61,28.61,0,0,1,0-57.22v-.02H524a16,16,0,0,0,16-16V540h73.37v39.61h-.14a84.605,84.605,0,1,0,169.21,0h-.03V540H856Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechData);
export default __webpack_public_path__ + "static/media/TechData.d3906344.svg";
export { ForwardRef as ReactComponent };